import '@mdi/font/css/materialdesignicons.css'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import { statusMessages } from '@chemtracepro/locales'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import en from './i18n/locales/en.json'
import nl from './i18n/locales/nl.json'

/**
 * Merge shared status translations with app-specific messages.
 * Shared status values take precedence to ensure consistency.
 */
const messages = {
  en: { ...en, ...statusMessages.en },
  nl: { ...nl, ...statusMessages.nl },
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)
app.use(i18n)

app.mount('#app')
